/**
 * @generated SignedSource<<ca6d73dad77687f7356638b9d469bc27>>
 * @relayHash 15afe768410f467f58512813804488cf
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 5a3abe148fa3378330c33399b2f78b01611b1b606d0218e858c383795a3ec93d

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { HorizontalNavJiraInnerQuery } from './HorizontalNavJiraInnerQuery.graphql';

import isJiraCustomTemplatesUxEnabled_provider from '@atlassian/jira-relay-provider/src/jira-custom-templates-ux-fg.relayprovider';
import showInviteButton_provider from '@atlassian/jira-relay-provider/src/jira-invite-button.relayprovider';
import fetchTeamCount_provider from '@atlassian/jira-relay-provider/src/jira-team-button-team-count.relayprovider';

const node: PreloadableConcreteRequest<HorizontalNavJiraInnerQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "5a3abe148fa3378330c33399b2f78b01611b1b606d0218e858c383795a3ec93d",
    "metadata": {},
    "name": "HorizontalNavJiraInnerQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__atlassianjirarelayprovidersrcjiracustomtemplatesuxfgrelayprovider": isJiraCustomTemplatesUxEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjirainvitebuttonrelayprovider": showInviteButton_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjirateambuttonteamcountrelayprovider": fetchTeamCount_provider
    }
  }
};

export default node;
